var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 0.883911C7.7 0.395556 7.28748 0 6.77939 0H6.77818L4.80751 0.00115999C2.15697 0.00347996 0 2.07406 0 4.61675V6.81609C0 7.30328 0.412522 7.7 0.920613 7.7C1.4287 7.7 1.84244 7.30328 1.84244 6.81609V4.61675C1.84244 3.04729 3.17315 1.77014 4.80872 1.76782L6.77939 1.76666C7.28869 1.76666 7.7 1.37111 7.7 0.883911Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 21.1161C7.7 21.6044 7.28748 22 6.77939 22H6.77818L4.80751 21.9988C2.15697 21.9965 0 19.9259 0 17.3832V15.1839C0 14.6967 0.412522 14.3 0.920613 14.3C1.4287 14.3 1.84244 14.6967 1.84244 15.1839V17.3832C1.84244 18.9527 3.17315 20.2299 4.80872 20.2322L6.77939 20.2333C7.28869 20.2333 7.7 20.6289 7.7 21.1161Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 0.883911C14.3 0.395556 14.7125 0 15.2206 0H15.2218L17.1925 0.00115999C19.843 0.00347996 22 2.07406 22 4.61675V6.81609C22 7.30328 21.5875 7.7 21.0794 7.7C20.5713 7.7 20.1576 7.30328 20.1576 6.81609V4.61675C20.1576 3.04729 18.8269 1.77014 17.1913 1.76782L15.2206 1.76666C14.7113 1.76666 14.3 1.37111 14.3 0.883911Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 21.1161C14.3 21.6044 14.7125 22 15.2206 22H15.2218L17.1925 21.9988C19.843 21.9965 22 19.9259 22 17.3832V15.1839C22 14.6967 21.5875 14.3 21.0794 14.3C20.5713 14.3 20.1576 14.6967 20.1576 15.1839V17.3832C20.1576 18.9527 18.8269 20.2299 17.1913 20.2322L15.2206 20.2333C14.7113 20.2333 14.3 20.6289 14.3 21.1161Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6733 5.5H15.2904C15.9594 5.5 16.5022 6.04747 16.5022 6.72285V8.35349C16.5022 9.02836 15.9594 9.57634 15.2904 9.57634H13.6733C13.0037 9.57634 12.4609 9.02836 12.4609 8.35349V6.72285C12.4609 6.04747 13.0037 5.5 13.6733 5.5Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71233 5.5H8.32893C8.9985 5.5 9.54126 6.04747 9.54126 6.72285V8.35349C9.54126 9.02836 8.9985 9.57634 8.32893 9.57634H6.71233C6.04276 9.57634 5.5 9.02836 5.5 8.35349V6.72285C5.5 6.04747 6.04276 5.5 6.71233 5.5Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71233 12.4238H8.32893C8.9985 12.4238 9.54126 12.9713 9.54126 13.6472V15.2773C9.54126 15.9527 8.9985 16.5002 8.32893 16.5002H6.71233C6.04276 16.5002 5.5 15.9527 5.5 15.2773V13.6472C5.5 12.9713 6.04276 12.4238 6.71233 12.4238Z",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6733 12.4238H15.2904C15.9594 12.4238 16.5022 12.9713 16.5022 13.6472V15.2773C16.5022 15.9527 15.9594 16.5002 15.2904 16.5002H13.6733C13.0037 16.5002 12.4609 15.9527 12.4609 15.2773V13.6472C12.4609 12.9713 13.0037 12.4238 13.6733 12.4238Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteQrCode);
export default __webpack_public_path__ + "static/media/CompleteQRCode.4a6df05906ccc488e1cc7d75661dc3a6.svg";
export { ForwardRef as ReactComponent };